var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#E7F6EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 41.125C35.2487 41.125 41.125 35.2487 41.125 28C41.125 20.7513 35.2487 14.875 28 14.875C20.7513 14.875 14.875 20.7513 14.875 28C14.875 35.2487 20.7513 41.125 28 41.125ZM33.36 26.1588C33.9539 25.6148 33.9944 24.6923 33.4505 24.0984C32.9065 23.5044 31.984 23.4639 31.39 24.0079L26.0058 28.9391L24.61 27.6608C24.016 27.1168 23.0935 27.1573 22.5496 27.7513C22.0056 28.3452 22.0461 29.2677 22.64 29.8117L25.0208 31.9921C25.5782 32.5026 26.4333 32.5026 26.9907 31.9921L33.36 26.1588Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadSuccess);
export default __webpack_public_path__ + "static/media/file_upload_success.11761b8ab008a6d4ca657fb9628fccad.svg";
export { ForwardRef as ReactComponent };